import images from "@/helpers/images";
//import functions from "@/helpers/functions";

export default {
    install(Vue) {        
        Vue.prototype.$images = images;
        //Vue.prototype.$functions = functions;
        
    }
};